import { useTenantBranding } from '../../contexts/ThemeContext';

interface SidebarLogoProps {
  collapsed: boolean;
}

export function SidebarLogo({ collapsed }: SidebarLogoProps) {
  const { branding } = useTenantBranding();

  if (collapsed) {
    // Show first 2 letters of firm name as abbreviated mark
    const initials = branding.firm_name
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word[0] ?? '')
      .join('')
      .toUpperCase();

    return (
      <div className="flex items-center justify-center h-14 px-2">
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0"
          style={{
            backgroundColor: 'var(--cime-gold)',
            color: 'var(--cime-sidebar-logo-text)',
          }}
        >
          {initials}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center h-14 px-4">
      {branding.logo_url ? (
        <img
          src={branding.logo_url}
          alt={branding.firm_name}
          className="h-8 object-contain"
        />
      ) : (
        <span
          className="text-lg font-bold truncate"
          style={{
            color: 'var(--cime-sidebar-logo-text)',
            fontFamily: 'var(--cime-font-heading)',
          }}
        >
          {branding.firm_name}
        </span>
      )}
    </div>
  );
}
